import { useEffect, useState } from 'react'
import { useLocation, useParams } from 'react-router-dom'
import { useAtom, useSetAtom } from 'jotai'
import { apiName } from 'config/api'
import { API } from 'lib/api'
import { searchTriggerAtom, messageAtom, spinnerAtom } from 'store/commonAtoms'


export const useSearch = (target) => {
    const [query, setQuery] = useState([])
    const [trigger, setTrigger] = useAtom(searchTriggerAtom)
    const { page, cond } = useSearchUrl()
    const setMessage = useSetAtom(messageAtom)
    const setSpinner = useSetAtom(spinnerAtom)

    useEffect(() => {
        if (trigger) {
            (async () => {
                setSpinner(true)
                const ret = await API.post(apiName, `/items/get${target}`, {
                    body: {
                        cond: cond,
                        offset: (page - 1) * 10,
                    }
                })
                ret.totalCount = Number(ret.totalCount || 0)

                ret.records = ret.records?.map(r => {
                    const to = target === 'PressReleases' ? `/post/pressrelease/${r.取引先ID}/${r.リリースNo}`
                        : target === 'NewsLetters' ? `/post/newsletter/${r.クライアント企業ID}/${r.ネタNo}`
                        : target === 'Inquiries' ? `/post/inquiry/${r.企業ID}/${r.企業探訪No}`
                        : `/company/${r.企業ID}`
                    return {
                        ...r,
                        公開日: new Date(r.公開日),
                        to: to,
                    }
                }) || []


                ret.isLoading = false
                setQuery(ret)
                setTrigger(false)
                if (ret.error || ret.message) {
                    setMessage({ type: 'error', text: '検索できませんでした。スペース区切りのワードを減らして再度お試しください' })
                }
                setSpinner(false)
            })()
        }

    }, [trigger, cond, page, target, setMessage, setTrigger])

    return query
}

export const useSearchUrl = () => {
    const { pathname, search } = useLocation()
    const { page } = useParams()

    const p = new URLSearchParams(search)

    const cond = {
        キーワード : p.get('キーワード') || '',
        地域 : p.get('地域') || '',
        上場 : p.get('上場') === 'true',
        業種 : p.get('業種') || '',
        カテゴリー : (p.get('カテゴリー') || '').split(',').filter(v => v),
    }

    return {
        path: pathname.replace(/\/\d+$/, ''),
        page: Number(page || 0),
        cond,
    }
}
